module.exports = __webpack_public_path__ + "static/index/assets/img/1.390d99ce.png";